import { createContext, useContext } from 'react';
import { SellerOnboardingContextProps } from './types';

export const SellerOnboardingContext =
  createContext<SellerOnboardingContextProps>(null as any);

export const useSellerOnboardingContext = () =>
  useContext(SellerOnboardingContext);
